export default "__VITE_ASSET__D7wGj0QE__"